import { Chip, Skeleton } from "@mui/material";
import { createElement, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SoftColor } from "@/constants/colors";
import { passengerStatuses } from "@/constants/passengerStatuses";
import { PASSENGER_STATUS } from "@/constants/status";

export function PassengerStatusSkeleton() {
    return (
        <div className=" h-6">
            <Skeleton variant="rounded" className="!rounded-full" width={200} height={19.5} />
        </div>
    );
}

function PassengerStatus({
    status,
    color,
    size = "medium",
}: {
    status: PASSENGER_STATUS;
    color?: SoftColor;
    size?: "small" | "medium";
}) {
    const { t } = useTranslation();

    const item = useMemo(() => passengerStatuses.find((item) => item.status === status), [status]);

    return item ? (
        <Chip
            size={size}
            sx={{
                backgroundColor: color?.bg || item.bg,
                color: color?.text || item.hover,
                fontWeight: 500,
            }}
            icon={createElement(item.component(), {
                color: color?.text || item.hover,
            })}
            label={t("passengerStatuses." + item.status)}
        />
    ) : null;
}

export default PassengerStatus;
